define('companiesDetailBodySubaccountsView',[
  'app',
  'module',
  'marionette',
  'backbone',
  'underscore',
  'companiesDetailBodySubaccountRowView',
  'template!companiesDetailBodySubaccountsView'
], function (
  App,
  Module,
  Marionette,
  Backbone,
  _,
  RowView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    className: 'companies-detail-subaccounts-view',
    childView: RowView,
    childViewContainer: 'tbody.subaccount-rows',

    childEvents: {
      'selected': function (child) {
        App.navigate('customers/' + child.model.get('secId') + '/profile', {trigger: true});
      }
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
    },

    onShow: function () {
      this.model.getEndUsers().done(_.bind(function (items) {
        this.collection.reset(items);
      }, this));
    }
  });
});

